/* src/app/modules_v2/booking/components/booking-reports/sales-report/sales-report.component.scss */
.informe-ventas .seccion-grafico {
  margin-bottom: 2rem;
}
.informe-ventas .seccion-grafico h3 {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #4d4e56;
}
.informe-ventas .seccion-grafico .contenedor-grafico {
  position: relative;
  height: 280px;
}
.informe-ventas .seccion-kpis {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
  margin-bottom: 3rem;
}
.informe-ventas .seccion-kpis .tarjeta-kpi {
  background:
    linear-gradient(
      135deg,
      #0066cc 0%,
      #0052a3 100%);
  color: white;
  padding: 1.5rem;
  border-radius: 4px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 102, 204, 0.1);
  transition: transform 0.2s, box-shadow 0.2s;
}
.informe-ventas .seccion-kpis .tarjeta-kpi:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(0, 102, 204, 0.2);
}
.informe-ventas .seccion-kpis .tarjeta-kpi .etiqueta-kpi {
  font-size: 0.875rem;
  opacity: 0.9;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.informe-ventas .seccion-kpis .tarjeta-kpi .valor-kpi {
  font-size: 1.75rem;
  font-weight: 700;
  margin-bottom: 0.25rem;
}
.informe-ventas .seccion-kpis .tarjeta-kpi .unidad-kpi {
  font-size: 0.75rem;
  opacity: 0.8;
  text-transform: uppercase;
}
.informe-ventas .seccion-tabla {
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 1.5rem;
  margin-bottom: 2rem;
}
.informe-ventas .seccion-tabla h3 {
  margin: 0 0 1.5rem 0;
  color: #333;
  font-size: 1.1rem;
}
.informe-ventas .seccion-tabla .tabla-responsiva {
  overflow-x: auto;
}
.informe-ventas .seccion-tabla .tabla-informe {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}
.informe-ventas .seccion-tabla .tabla-informe thead {
  background-color: #f5f5f5;
  border-bottom: 2px solid #ddd;
}
.informe-ventas .seccion-tabla .tabla-informe thead th {
  padding: 0.75rem;
  text-align: left;
  font-weight: 600;
  color: #333;
  text-transform: uppercase;
  font-size: 0.8rem;
  letter-spacing: 0.05em;
}
.informe-ventas .seccion-tabla .tabla-informe tbody tr {
  border-bottom: 1px solid #ddd;
  transition: background-color 0.2s;
}
.informe-ventas .seccion-tabla .tabla-informe tbody tr:hover {
  background-color: #f9f9f9;
}
.informe-ventas .seccion-tabla .tabla-informe tbody tr td {
  padding: 0.75rem;
  color: #333;
}
.informe-ventas .seccion-tabla .tabla-informe tbody tr td.texto-derecha {
  text-align: right;
  font-weight: 600;
}
.informe-ventas .seccion-tabla .tabla-informe tbody tr td .insignia-estado {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.informe-ventas .seccion-tabla .tabla-informe tbody tr td .insignia-estado.estado-completed {
  background-color: #d4edda;
  color: #155724;
}
.informe-ventas .seccion-tabla .tabla-informe tbody tr td .insignia-estado.estado-pending {
  background-color: #fff3cd;
  color: #856404;
}
.informe-ventas .seccion-tabla .tabla-informe tbody tr td .insignia-estado.estado-cancelled {
  background-color: #f8d7da;
  color: #721c24;
}
.informe-ventas .seccion-tabla .tabla-informe tbody tr td .insignia-estado.estado-confirmed {
  background-color: #d1ecf1;
  color: #0c5460;
}
.informe-ventas .seccion-tabla .sin-datos {
  text-align: center;
  color: #999;
  padding: 2rem;
  margin: 0;
}
@media (max-width: 768px) {
  .informe-ventas .seccion-kpis {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 1rem;
  }
  .informe-ventas .seccion-kpis .tarjeta-kpi {
    padding: 1rem;
  }
  .informe-ventas .seccion-kpis .tarjeta-kpi .valor-kpi {
    font-size: 1.25rem;
  }
  .informe-ventas .seccion-tabla {
    padding: 1rem;
  }
  .informe-ventas .seccion-tabla .tabla-informe {
    font-size: 0.8rem;
  }
  .informe-ventas .seccion-tabla .tabla-informe th,
  .informe-ventas .seccion-tabla .tabla-informe td {
    padding: 0.5rem;
  }
}
/*# sourceMappingURL=sales-report.component.css.map */
